import { useContext, useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

function Profile() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const token = localStorage.getItem("token");
  const storedUser = localStorage.getItem("user");

  useEffect(() => {
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setName(parsedUser.name);
      setEmail(parsedUser.email);
    }
  }, []);

  return (
    <>
      <div style={{ marginBottom: '100px' }}></div>
      <div className="py-5 bg-light">
        <div className="container">
          <div className="row justify-content-center">

            <div className="col-lg-6 col-md-8">
              <div className="card border-0 shadow-lg rounded-4">

                <div className="card-header bg-primary text-white text-center rounded-top-4 py-4">
                  <i className="bi bi-person-circle fs-1"></i>
                  <h4 className="mt-2 mb-0">My Profile</h4>
                </div>

                <div className="card-body p-4">

                  <div className="mb-4 text-center">
                    <div
                      className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center mx-auto"
                      style={{ width: "90px", height: "90px", fontSize: "32px" }}
                    >
                      {name ? name.charAt(0).toUpperCase() : "U"}
                    </div>
                    <h5 className="mt-3 mb-0">{name}</h5>
                    <small className="text-muted">{email}</small>
                  </div>

                  <hr />

                  <div className="row mb-3">
                    <div className="col-4 fw-semibold text-muted">
                      Name
                    </div>
                    <div className="col-8">
                      {name}
                    </div>
                  </div>

                  <div className="row mb-4">
                    <div className="col-4 fw-semibold text-muted">
                      Email
                    </div>
                    <div className="col-8">
                      {email}
                    </div>
                  </div>

                  <div className="d-grid">
                    <NavLink
                      to="/profile-update"
                      className="btn btn-primary rounded-3"
                    >
                      <i className="bi bi-pencil-square me-2"></i>
                      Edit Profile
                    </NavLink>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
}

export default Profile;
